














import { Component, Prop, Vue } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { getFileNameFromHeader, base64ToArrayBuffer } from '../utils/helpers'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class ZoneTextInfo extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private data!: any
    @Prop() storeDocument!: Function | null
    @Prop() getDocument!: Function | null
    @Prop() deleteDocument!: Function | null
    @Prop({ default: false }) check_validation!: boolean

    /** 
     * download 
     * Télécharge un fichier en créant un lien de téléchargement et en déclenchant le téléchargement. 
     * @param {any} file - Le fichier à télécharger. 
     */
    download(file: any) {
        if (file.data) {
            const url = file.data
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'Download',
                file.titre
            )
            document.body.appendChild(link)
            link.click()
        } else {
            if (this.getDocument) {
                this.getDocument(file.id).then((response: any) => {
                    let fileName = ''
                    const fileNameTemp = getFileNameFromHeader(response.headers) || file.titre
                    if (fileNameTemp) {
                        fileName = fileNameTemp
                    }
                    const url = URL.createObjectURL(new Blob([base64ToArrayBuffer(response.data)]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'Download',
                        fileName
                    )
                    document.body.appendChild(link)
                    link.click()
                })
            }
        }
    }
}
